package com.eladfinish.bible.contest.ui.components.buttons

import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.TextUnit
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp

@Composable
fun ItemButtonTextWithLongClick(
    modifier: Modifier = Modifier,
    text: String,
    enabled: Boolean = true,
    textColor: Color = Color.White,
    fontSize: TextUnit = 16.sp,
    transparentBackground: Boolean = false,
    borderWidth: Int = 1,
    contentPadding: PaddingValues = PaddingValues(
        horizontal = 16.dp,
        vertical = 10.dp,
    ),
    onClick: () -> Unit,
    onLongClick: (() -> Unit)? = null,
) {
    ItemButtonWithLongClick(
        modifier = modifier,
        enabled = enabled,
        transparentBackground = transparentBackground,
        borderWidth = borderWidth,
        contentPadding = contentPadding,
        onClick = onClick,
        onLongClick = onLongClick,
    ) {
        Text(
            text = text,
            fontSize = fontSize,
            style = MaterialTheme.typography.labelLarge,
            textAlign = TextAlign.Center,
            color = if (enabled) {
                textColor
            } else {
                textColor.copy(alpha = 0.5f)
            },
        )
    }
}

@Preview
@Composable
private fun ItemButtonTextPreview() {
    ItemButtonTextWithLongClick(
        text = "כפתור לדוגמא",
        onClick = {},
    )
}

@Preview
@Composable
private fun ItemButtonTextTransparentPreview() {
    ItemButtonTextWithLongClick(
        text = "כפתור שקוף",
        transparentBackground = true,
        onClick = {},
    )
}

@Preview
@Composable
private fun ItemButtonTextDisabledPreview() {
    ItemButtonTextWithLongClick(
        text = "כפתור מבוטל",
        enabled = false,
        onClick = {},
    )
}
